
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (data.length) { 
    ; __append("\n    ")
    ;  for(var i=0; i < data.length; i++) { 
    ; __append("\n<li class=\"clearfix ")
    ;  if (data[i].peertrying) {
    ; __append("peertring")
    ;  }
    ; __append("\">\n	<div class=\"info-box\">\n		<p>块号索引：<span class=\"num\">")
    ; __append(escape(data[i].mBlockId))
    ; __append("</span></p>\n		<p>总字节数：<span class=\"total-num\">")
    ; __append(escape(data[i].mEndPos-data[i].mStartPos+1))
    ; __append("</span></p>\n		<p>p2p已下载字节数：")
    ; if (data[i].P2PDataLength){
    ; __append(escape(data[i].P2PDataLength))
    ; }
    ; __append("</p>\n		<p>VDN已下载字节数：")
    ; if (data[i].P2PDataLength) {
    ; __append(escape(data[i].mDataLength - data[i].P2PDataLength))
    ; } else {
    ; __append(escape(data[i].mDataLength))
    ;  }
    ; __append("</p>\n		<p>是否有从VDN下载：</p>\n		<p>状态：</p>\n		<p>p2p连接重试次数：0</p>\n		<p>vdn连接重试次数：0</p>\n	</div>\n	<div class=\"left vdn\" style=\"width:")
    ;  if (data[i].P2PDataLength) {
    ; __append(escape((data[i].mDataLength-data[i].P2PDataLength)/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  } else {
    ; __append(escape(data[i].mDataLength/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  }
    ; __append("\"></div>\n	<div class=\"right peer\" style=\"width:")
    ;  if (data[i].P2PDataLength) {
    ; __append(escape((data[i].P2PDataLength)/(data[i].mEndPos-data[i].mStartPos+1)*100+'%'))
    ;  } else {
    ; __append("0%")
    ;  }
    ; __append("\"></div>\n	<div class=\"playing\"></div>\n</li>\n    ")
    ;  } 
    ; __append("\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./components/f.component.mediasource/app/modules/consoleInfo.tpl
// module id = Lfvx
// module chunks = 0